module.exports = __webpack_public_path__ + "ea4da9a6767296238b17a90b728cb703.svg";